import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import CustomDialog from "../common/tableComponent.js/dialog";
import { transactionHistoryRequest } from "../common/customServiceCall/serviceCall";
import { useSelector } from "react-redux";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import { format } from "date-fns";

const TransactionActivityByTransId = (props) => {
  const userDetails = useSelector((state) => state.login.userDetails);
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [dateRange, setDateRange] = useState(null);

  const fetchHistoryData = async () => {
    setLoading(true); // Start loading

    const requestData = {
      startDate:
        dateRange && dateRange[0] ? format(dateRange[0], "yyyy-MM-dd") : "", // Check if dateRange and startDate are valid
      endDate:
        dateRange && dateRange[1] ? format(dateRange[1], "yyyy-MM-dd") : "",
      size: "9999999",
      page: "1",
    };
    const filteredRequestData = Object.fromEntries(
      Object.entries(requestData).filter(([key, value]) => value !== "")
    );
    const queryString = new URLSearchParams(filteredRequestData).toString();
    const transactionId = props.match.params.transId;
    try {
      const response = await transactionHistoryRequest(
        "get",
        `api/v1/history/transaction/q?transactionId=${transactionId}&${queryString}`
      );
      if (response.code === "TXNHS000") {
        const responseData = response.data;
        console.log(responseData, "historydata");
        setCustomers(responseData);
      } else {
        console.error("Failed to fetch data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchHistoryData();
  }, [dateRange]); // Re-fetch data when filters change


  const dateTemplate = (rowData) => {
    return <p>{format(new Date(rowData.createdAt), "yyyy-MM-dd HH:mm:ss")}</p>;
  };

  console.log(customers, "customers");
  return (
    <section className="p-my-4 p-md-12 p-xl-12" style={{ padding: "0px 10%" }}>
      <Toast ref={toast} />

      <div className="p-grid p-fluid">
        <div
          className="p-col-12 p-sm-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
          style={{ textAlign: "center" }}
        >
          <span className="p-tag custom-heading">Activity History</span>
        </div>
      </div>

      <div className="card" style={{ paddingTop: "0px" }}>
        <div
          className="p-grid p-align-center p-fluid"
          style={{ paddingTop: "30px" }}
        >
          {/* Date Range Picker */}
          <div className="p-field p-col-12 p-md-3">
            <span className="p-float-label">
              <Calendar
                value={dateRange}
                onChange={(e) => setDateRange(e.value)} // Set date range
                selectionMode="range"
                readOnlyInput
                showIcon
                placeholder="Select Date Range"
              />
            </span>
          </div>
        </div>
      </div>
      <div className="card">
        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <ProgressSpinner
              style={{
                display: userDetails.showLoader,
                width: "40px",
                height: "40px",
                position: "fixed",
                top: "50%",
                left: "50%",
                bottom: "50%",
                right: "50%",
                zIndex: "1111111111",
              }}
              strokeWidth="3"
              animationDuration=".5s"
            />
          </div>
        ) : (
          <DataTable
            value={customers}
            paginator
            rows={5}
            rowsPerPageOptions={[5, 10, 25, 50]}
            tableStyle={{ minWidth: "60rem" }}
            className="p-datatable-responsive-demo"
          >
            <Column
              field="transactionId"
              header="Transaction Id"
              style={{ width: "50%" }}
            ></Column>
            <Column
              field="reportingComponent"
              header="Reporting Component"
              style={{ width: "35%" }}
            ></Column>

            <Column
              field="stageReached"
              header="Stage Reached"
              style={{ width: "25%" }}
            ></Column>
            <Column
              field="stageOutcome"
              header="Stage Outcome"
              style={{ width: "25%" }}
            ></Column>
            <Column
              field="nextAction"
              header="Next Action"
              style={{ width: "25%" }}
            ></Column>

            <Column
              field="createdAt"
              header="Created At"
              style={{ width: "25%" }}
              body={dateTemplate}
            ></Column>
          </DataTable>
        )}
      </div>
    </section>
  );
};

export default TransactionActivityByTransId;
